import { BrandLoader } from "./BrandLoader";

export function TableLoadingOverlay() {
  return (
    <BrandLoader label="Loading records..." />
  );
}